// @flow

import HeroPrimary from "./HeroPrimary"
import TitlePrimary from "./TitlePrimary"
import TitleSecondary from "./TitleSecondary"
import LabelPrimary from "./LabelPrimary"
import ParagraphPrimary from "./ParagraphPrimary"
import ParagraphSecondary from "./ParagraphSecondary"
import Link from "./Link"

export {
  HeroPrimary,
  TitlePrimary,
  TitleSecondary,
  LabelPrimary,
  ParagraphPrimary,
  ParagraphSecondary,
  Link
}
